export default {
    lang: {
        name: 'Lastname'
    }
}